// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__+1dgT","label":"style_label__YDbAB","phone":"style_phone__sjVz+","error":"style_error__Kl7EX"};